import { useSearchParams, useNavigate } from 'react-router-dom';

export default function PaymentComplete() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const status = searchParams.get('status');
  const transactionId = searchParams.get('transaction_id');

  return (
    <div className="container mx-auto p-6">
      <div className="max-w-md mx-auto bg-white rounded-lg shadow-md p-6">
        <h1 className="text-2xl font-bold mb-4">
          {status === 'success' ? 'Payment Successful!' : 'Payment Status'}
        </h1>
        
        {status === 'success' && (
          <div className="text-green-600">
            <p>Transaction ID: {transactionId}</p>
            <p>Your payment has been processed successfully.</p>
          </div>
        )}
        
        {status === 'failed' && (
          <div className="text-red-600">
            <p>The payment could not be processed.</p>
            <p>Please try again or contact support.</p>
          </div>
        )}
        
        <button
          onClick={() => navigate('/virtual-terminal')}
          className="mt-4 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
        >
          Return to Virtual Terminal
        </button>
      </div>
    </div>
  );
} 